import { Button } from "@kanda-libs/ks-design-library";
import Profile from "components/shared/Profile";
import type { FunctionComponent } from "react";
import CloseLeadModal from "./CloseLeadModal";
import CreateJobFromLeadModal from "./CreateJobFromLeadModal";
import useLeadActions from "./useLeadActions";

const LeadActions: FunctionComponent = function () {
  const {
    lead,
    isLoading,
    onClickCreateJobFromLead,
    onClickCloseLead,
    onCreateJobFromLead,
    onCloseLead,
  } = useLeadActions();

  if (lead?.status === "closed") return <></>;

  return (
    <Profile.Section title="Actions">
      <>
        <div className="flex flex-col gap-y-2">
          {lead?.status === "open" && (
            <Button.Text
              id="staff-create-job-from-lead"
              label="Create job from lead"
              size={40}
              isLoading={isLoading}
              onClick={onClickCreateJobFromLead}
            />
          )}
          <Button.Text
            id="staff-close-lead"
            label="Close lead"
            size={40}
            variant="danger"
            isLoading={isLoading}
            onClick={onClickCloseLead}
          />
        </div>
        <CloseLeadModal onCloseLead={onCloseLead} />
        <CreateJobFromLeadModal onCreateJobFromLead={onCreateJobFromLead} />
      </>
    </Profile.Section>
  );
};

export default LeadActions;
